import type { ReduxError } from './ReduxError.types';
import { isApiSerializedError } from './isApiSerializedError';

/**
 * Flattens any caught value into a Redux-safe `ReduxError`.
 *
 * `catchError((err) => …)` types `err` as `unknown` and at runtime it can be:
 * - the plain object thrown by ApiClient (api failure),
 * - a raw `Error`,
 * - a primitive or undefined.
 *
 * The hardcoded `fallbackMessage` is preserved as the user-facing `message`;
 * any API metadata is preserved in `apiError` for debugging.
 */
export const toReduxError = (caught: unknown, fallbackMessage: string): ReduxError => {
  if (isApiSerializedError(caught)) {
    return {
      message: fallbackMessage,
      apiError: {
        message: caught.message,
        statusCode: caught.status,
        data: caught.data,
        url: caught.url,
        method: caught.method,
      },
    };
  }
  if (caught instanceof Error) {
    return { message: fallbackMessage, apiError: { message: caught.message } };
  }
  return { message: fallbackMessage };
};
